import { Container, Title, Text, Stack, Group, SimpleGrid } from '@mantine/core';
import { useTheme } from '../theme/theme';
import { assets } from '../assets';

export const FootprintPage = () => {
  const theme = useTheme();

  return (
    <Container size='md' py='xl'>
      <Stack gap='xl'>
        <Group gap='lg' align='center'>
          <assets.LogoSquare.Component width={48} height={48} />
          <div>
            <Title order={1}>About epilogo.</Title>
            <Text c={theme.v0.col.textSecondary.hex}>
              The company behind epilogo.
            </Text>
          </div>
        </Group>

        <div>
          <Title order={2} size='h3' mb='sm'>
            Our Mission
          </Title>
          <Text style={{ lineHeight: 1.8 }}>
            Epilogo SRL builds tools that help professionals and creators share their expertise with the world. We
            believe everyone has valuable knowledge worth sharing — the bottleneck has always been the time and effort
            required to create content. epilogo removes that bottleneck.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='sm'>
            Company Details
          </Title>
          <SimpleGrid cols={{ base: 1, sm: 2 }} spacing='lg'>
            <div>
              <Text size='sm' c={theme.v0.col.textDimmed.hex} mb={4}>
                Legal name
              </Text>
              <Text fw={500}>Epilogo SRL</Text>
            </div>
            <div>
              <Text size='sm' c={theme.v0.col.textDimmed.hex} mb={4}>
                Registered in
              </Text>
              <Text fw={500}>Italy</Text>
            </div>
            <div>
              <Text size='sm' c={theme.v0.col.textDimmed.hex} mb={4}>
                General inquiries
              </Text>
              <Text fw={500}>hello@epilogo.co</Text>
            </div>
            <div>
              <Text size='sm' c={theme.v0.col.textDimmed.hex} mb={4}>
                Website
              </Text>
              <Text fw={500}>epilogo.co</Text>
            </div>
          </SimpleGrid>
        </div>

        <div>
          <Title order={2} size='h3' mb='sm'>
            What We Build
          </Title>
          <Text style={{ lineHeight: 1.8 }}>
            epilogo is our flagship product — a platform that turns short AI-driven interviews into polished,
            platform-optimized social media posts. We handle content generation, multi-platform publishing, and
            scheduling so our users can focus on what they do best: being experts in their field.
          </Text>
        </div>

        <div>
          <Title order={2} size='h3' mb='sm'>
            Contact
          </Title>
          <Stack gap='xs'>
            <Text>
              For support inquiries: <strong>support@epilogo.co</strong>
            </Text>
            <Text>
              For privacy-related requests: <strong>privacy@epilogo.co</strong>
            </Text>
            <Text>
              For partnerships: <strong>hello@epilogo.co</strong>
            </Text>
          </Stack>
        </div>
      </Stack>
    </Container>
  );
};
